import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

export type MigrationStatus = 'PENDING' | 'SUCCESS' | 'FAILED' | 'SKIPPED';

@Component({
  selector: 'app-migration-status',
  imports: [CommonModule, MatIconModule],
  template: `
    <div style="margin-top: 4px">
      <span class="migration-status" [class]="'status-' + (status | lowercase)">
        <mat-icon [style.font-size.px]="16" [style.height.px]="16" [style.width.px]="16">
          {{ getMigrationIcon(status) }}
        </mat-icon>
        {{ getMigrationLabel(status) }}
      </span>
      @if (error && status === 'FAILED') {
        <span style="color: #d32f2f; font-size: 12px; display: block; margin-top: 2px" [title]="error">
          {{ error.length > 50 ? (error | slice: 0 : 50) + '...' : error }}
        </span>
      }
    </div>
  `,
  styles: [
    `
      .migration-status {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 2px 6px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
      }

      .status-pending {
        background-color: #fff3cd;
        color: #856404;
      }

      .status-success {
        background-color: #d4edda;
        color: #155724;
      }

      .status-failed {
        background-color: #f8d7da;
        color: #721c24;
      }

      .status-skipped {
        background-color: #e2e3e5;
        color: #6c757d;
      }
    `,
  ],
})
export class MigrationStatusComponent {
  @Input() status!: MigrationStatus;
  @Input() error?: string;

  getMigrationIcon(status: MigrationStatus): string {
    switch (status) {
      case 'PENDING':
        return 'schedule';
      case 'SUCCESS':
        return 'check_circle';
      case 'FAILED':
        return 'error';
      case 'SKIPPED':
        return 'skip_next';
      default:
        return 'help';
    }
  }

  getMigrationLabel(status: MigrationStatus): string {
    switch (status) {
      case 'PENDING':
        return 'Pending';
      case 'SUCCESS':
        return 'Migrated';
      case 'FAILED':
        return 'Failed';
      case 'SKIPPED':
        return 'Skipped';
      default:
        return 'Unknown';
    }
  }
}
